import { profileTipsConstants } from './constants';

const {
  ADD_PROFESSION_NAME_AND_EXPERIENCE,
  ADD_PROFESSION_NAME,
  ADD_PROFESSION_EXPERIENCE,
  ADD_LOCATION,
  ADD_AN_INDUSTRY,
  ADD_MORE_THAN_ONE_INDUSTRY,
  ADD_A_COLLEGE_DEGREE,
  ADD_A_CERTIFICATION,
  ADD_A_SKILL,
  ADD_AT_LEAST_TEN_SKILLS,
  ADD_AN_ACCOMPLISHMENT,
  ADD_AT_LEAST_THREE_ACCOMPLISHMENTS,
  ADD_BIO,
  ADD_A_COMPANY,
  ADD_MORE_THAN_ONE_COMPANY
} = profileTipsConstants;

const generateProfileScore = (profile) => {
  let score = 100; // Start with max possible score and subtract points based on rules below.
  let tipsForImprovement = [];

  // PROFESSION
  if (profile.profession.name === '' && profile.profession.years_experience === undefined) {
    score -= 16;
    tipsForImprovement.push(ADD_PROFESSION_NAME_AND_EXPERIENCE);
  }

  if (profile.profession.name === '' && profile.profession.years_experience !== undefined) {
    score -= 4;
    tipsForImprovement.push(ADD_PROFESSION_NAME);
  }

  if (profile.profession.name !== '' && profile.profession.years_experience === undefined) {
    score -= 6;
    tipsForImprovement.push(ADD_PROFESSION_EXPERIENCE);
  }

  // LOCATION
  if (profile.location.current === '' && profile.location.undisclosed === false) {
    score -= 11;
    tipsForImprovement.push(ADD_LOCATION);
  }

  // INDUSTRIES
  if (profile.industries.current.length < 2) {
    if (profile.industries.current.length < 1) {
      score -= 13;
      tipsForImprovement.push(ADD_AN_INDUSTRY);
    } else {
      score -= 7;
      tipsForImprovement.push(ADD_MORE_THAN_ONE_INDUSTRY);
    }
  }

  // EDUCATION
  if (profile.education.degrees.length < 1) {
    score -= 11;
    tipsForImprovement.push(ADD_A_COLLEGE_DEGREE);
  }

  if (profile.education.certifications < 1) {
    score -= 2;
    tipsForImprovement.push(ADD_A_CERTIFICATION);
  }

  // SKILLS
  if (profile.skills.length < 10) {
    if (profile.skills.length < 1) {
      score -= 17;
      tipsForImprovement.push(ADD_A_SKILL);
    } else {
      score -= 11;
      tipsForImprovement.push(ADD_AT_LEAST_TEN_SKILLS);
    }
  }

  // ACCOMPLISHMENTS
  if (profile.accomplishments < 3) {
    if (profile.accomplishments < 1) {
      score -= 15;
      tipsForImprovement.push(ADD_AN_ACCOMPLISHMENT);
    } else {
      score -= 5;
      tipsForImprovement.push(ADD_AT_LEAST_THREE_ACCOMPLISHMENTS);
    }
  }

  // BIO
  if (profile.bio === '') {
    score -= 10;
    tipsForImprovement.push(ADD_BIO);
  }

  // COMPANIES
  if (profile.companies.length < 2) {
    if (profile.companies.length < 1) {
      score -= 15;
      tipsForImprovement.push(ADD_A_COMPANY);
    } else {
      score -= 10;
      tipsForImprovement.push(ADD_MORE_THAN_ONE_COMPANY);
    }
  }

  return { score, tipsForImprovement };
};

export default generateProfileScore;
